import * as React from "react";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {resourcesHelper} from "@ferry/portal-core";

interface IProps {
    title: React.ReactNode;
    isOpen: boolean;
    onClose?: () => void;
    onConfirm?: () => void;
}

export class RenewalCancelModal extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    public render() {
        const closeBtn = <button className="btn-close" onClick={this.handleCancelClick} />;

        return (
            <Modal className="edit-name-modal my-2 info-modal" isOpen={this.props.isOpen}>
                <ModalHeader close={closeBtn}>
                    <div className="d-flex">
                        <div className="info-popup-title">
                            <img src={`/${resourcesHelper.THEME_PATH}/img/info-popup.svg`} alt="Attention"/>
                            <div className="empty-column font-weight-medium">{this.props.title}</div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div>If you no longer wish to renew your policy then you can cancel here.</div>
                    <div>If you cancel before the policy has started then no payment will be taken.</div>
                </ModalBody>
                <div className="empty-column" />
                <ModalFooter className="renewal-reminder-footer">
                    <button type="button" className="btn-white" onClick={this.handleCancelClick}>
                        Cancel
                    </button>
                    <button type="button" className="btn-primary btn-next" onClick={this.handleConfirmClick}>
                        Cancel renewal
                    </button>
                </ModalFooter>
            </Modal>
        );
    }

    private handleCancelClick(): void {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    private handleConfirmClick(): void {
        if (this.props.onConfirm) {
            this.props.onConfirm();
        }
    }
}
